module.exports = __webpack_public_path__ + "img/safari_tips_kr.e1cccdaa.png";